export default "// Nothing to test here :)\n";